var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFCC00",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 13.458V12.4C9.6 8.86538 12.4654 6 16 6C19.5346 6 22.4 8.86537 22.4 12.4V13.458C22.4 15.7583 23.0649 18.0096 24.3146 19.9409L25 21H7L7.68539 19.9408C8.93512 18.0096 9.6 15.7583 9.6 13.458Z",
    stroke: "#F2C94C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.8887C15.5344 25.4825 16.4656 25.4825 17 24.8887",
    stroke: "#F2C94C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationbell);
export default __webpack_public_path__ + "static/media/notificationbell.99cfc6aefde1faa66ca188ceca2c0a59.svg";
export { ForwardRef as ReactComponent };